import { I18n } from 'react-redux-i18n';
import { validationMap } from '../network/api/types/compte/RequirementType';
import { EntityDTO } from '../network/api/types/compte/EntityDTO';
import { Entity, TypeEntityEnum } from '../network/api/types/compte/Entity';

export function validateNom(nom: string): boolean {
  return (nom !== null
    && validationMap.latinPattern(nom)
    && validationMap.surnamePattern(nom)
    && !validationMap.numeric(nom));
}

export function required(value: string | number | boolean): string {
  return value ? undefined : I18n.t('COLLABORATORS_INFORMATION.FIELD_MANDATORY_ERROR');
}

export function validateName(name: string): string {
  return (validationMap.latinPattern(name)
    && validationMap.surnamePattern(name)
    && !validationMap.numeric(name))
    ? undefined
    : I18n.t('COLLABORATORS_INFORMATION.NAME_ERROR');
}

export function validateDateDeNaissance(dateDeNaissance: string): boolean {
  try {
    const date = new Date(dateDeNaissance);
    const now = Date.now();

    if (date.getTime() >= now) {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
}

export function validateCommuneDeNaissance(communeDeNaissance: string): boolean {
  return validationMap.cityPattern(communeDeNaissance);
}

export function validatePhone(phone: string): string {
  if (!phone) {
    return undefined;
  }
  return validationMap.frenchPhone(phone) ? undefined : I18n.t('COLLABORATORS_INFORMATION.TEL_ERROR');
}

export function validateEmail(email: string): string {
  if (!email) return undefined;
  return validationMap.email(email) ? undefined : I18n.t('COLLABORATORS_INFORMATION.MAIL_ERROR');
}

export function validateUrl(url: string): string {
  if (!url) return undefined;
  return validationMap.url(url) ? undefined : I18n.t('COLLABORATORS_INFORMATION.URL_ERROR');
}

export function validateZipCode(zipCode: string): string {
  if (!zipCode) return undefined;
  return validationMap.zipCode(zipCode) ? undefined : I18n.t('STRUCTURE_INFORMATION.CODE_POSTAL_INVALID');
}

export function getStructureNameV2(entity: EntityDTO): string {
  if (TypeEntityEnum.INSTANCE === entity?.typeEntite.name) {
    return entity?.sigle;
  }
  return entity?.denominationSocialeAbregee
    || entity?.denominationSociale
  || entity?.intitule
  || entity?.sigle;
}

export function getStructureName(entity: Entity): string {
  if (TypeEntityEnum.INSTANCE === entity?.typeEntite) {
    return entity?.name || entity?.nomAbrege;
  }
  return entity?.ctmDenominationSocialeAbregee
    || entity?.ctmDenominationSociale
    || entity?.ctmIntitule || entity?.name || entity?.nomAbrege;
}
